<div>
  <div class="form-card flex-row left login-container">
    <div data-cy="login-welcome" class="form-card-header background-teal-sunrise">
      <div class="form-card-title" data-cy="welcome-title-1">Welcome to Calibrant!</div>
      @if (!resettingPassword) {
        <div class="form-card-subtitle" data-cy="welcome-title-2">Please enter your username and password</div>
      } @else {
        <div class="form-card-subtitle" data-cy="welcome-title-2">
          Please enter your username, old password and password
        </div>
      }
    </div>

    @if (!loggedIn) {
      <div class="form-card-body background-secondary" data-cy="credentials-container">
        <div class="form-card-body-wrapper">
          <form [formGroup]="loginForm" class="login-form">
            <div data-cy="items-start">
              <mat-form-field appearance="outline">
                <mat-label>Username</mat-label>
                <input matInput autofocus formControlName="username" [maxLength]="40" type="text" />
              </mat-form-field>

              @if (resettingPassword) {
                <div class="password-container">
                  <mat-form-field appearance="outline">
                    <mat-label>Old Password</mat-label>
                    <input
                      matInput
                      formControlName="oldPassword"
                      type="{{ oldPasswordShown ? 'text' : 'password' }}"
                      [maxLength]="40"
                    />
                  </mat-form-field>
                  <span class="show-password link" (click)="toggleShowOldPassword()">
                    <mat-icon>{{ passwordShown ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </span>
                </div>
              }

              <div class="password-container">
                <mat-form-field appearance="outline">
                  <mat-label>Password</mat-label>
                  <input
                    matInput
                    formControlName="password"
                    type="{{ passwordShown ? 'text' : 'password' }}"
                    [maxLength]="40"
                  />
                </mat-form-field>
                <span class="show-password link" (click)="toggleShowPassword()">
                  <mat-icon>{{ passwordShown ? 'visibility_off' : 'visibility' }}</mat-icon>
                </span>
              </div>

              @if (passwordField.errors?.['invalidPassword'] && resettingPassword) {
                <div class="error">
                  Passwords must contain at least 1 uppercase, 1 lowercase, 1 number and a minimum of 12 characters.
                </div>
              }
              @if (!resettingPassword) {
                <span class="change-password-button">
                  <span>Having Trouble Logging In?</span>
                  <a class="pad-left-5" (click)="toggleResetPassword()">Reset Password</a>
                </span>
              }
            </div>
            <div data-cy="login-controls-container" class="form-card-body text-center">
              @if (!resettingPassword) {
                <span class="login-button">
                  <button
                    class="flex items-center x-btn x-btn-primary"
                    (click)="login()"
                    type="submit"
                    [disabled]="loggingIn"
                  >
                    @if (loggingIn) {
                      <mat-spinner diameter="25"></mat-spinner>
                    } @else {
                      <span>Login</span>
                    }
                  </button>
                </span>
              }
              @if (resettingPassword) {
                <span class="submit-password-button">
                  <button
                    class="x-btn x-btn-primary"
                    (click)="resetPassword()"
                    [disabled]="!passwordField.valid || !passwordValid()"
                    type="submit"
                  >
                    Submit Password
                  </button>
                </span>
              }
              @if (resettingPassword) {
                <span class="cancel-button">
                  <button class="x-btn x-btn-secondary" (click)="toggleResetPassword()">Cancel</button>
                </span>
              }
            </div>
          </form>
        </div>
      </div>
    } @else {
      <div class="form-card-body background-secondary">
        <div class="mb-4">
          <h5>You are now logged in, select an app from the list below or wait for the redirect</h5>
        </div>
        @if (isAdmin) {
          <div class="pad-top-20">
            <a href="/admin">Go to Admin</a>
          </div>
        }
        <div class="card-container">
          @for (app of apps; track app) {
            <div class="card" (click)="goTo(app.url)">
              <div class="card-front">
                <span class="card-title">{{ app.displayLabel }}</span>
                <mat-icon>home</mat-icon>
              </div>
              <div class="card-back">
                <p class="card-description">This is the description of the card.</p>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
